module.exports = __webpack_public_path__ + "static/media/venvi1.a4c1e763.gif";